import { useRef, useEffect } from 'react';
import { jsx } from '@emotion/react';

var OffClickWrapper = _ref => {
  var {
    children,
    className,
    onOffClick
  } = _ref;
  var containerRef = useRef(null);

  var handleKeyPress = event => {
    if (event.key === 'Escape') {
      onOffClick(event);
    }
  };

  var handleOffClick = event => {
    var node = containerRef.current;

    if (!node) {
      return;
    }

    if (node.contains(event.target)) {
      return;
    }

    onOffClick(event);
  };

  useEffect(() => {
    document.addEventListener('click', handleOffClick, {
      capture: true
    });
    document.addEventListener('keydown', handleKeyPress, {
      capture: true
    });
    return () => {
      document.removeEventListener('click', handleOffClick, false);
      document.removeEventListener('keydown', handleKeyPress, false);
    };
  }, []);
  return jsx("div", {
    ref: containerRef,
    className: className
  }, children);
};

export { OffClickWrapper };
